/**
 * Generated by orval v6.28.2 🍺
 * Do not edit manually.
 * Maybern
 * Maybern API
 * OpenAPI spec version: 0.0.0
 */

export type DocumentTypeEnum = typeof DocumentTypeEnum[keyof typeof DocumentTypeEnum];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DocumentTypeEnum = {
  cover_letter: 'cover_letter',
  event_template: 'event_template',
  investment_memo: 'investment_memo',
  investor_transfer: 'investor_transfer',
  notice: 'notice',
  notice_detail: 'notice_detail',
  ilpa_notice_workbook: 'ilpa_notice_workbook',
  integration_test: 'integration_test',
  report: 'report',
  side_letter: 'side_letter',
  tax_withholding: 'tax_withholding',
  distribution_withholding: 'distribution_withholding',
  image: 'image',
  waterfall_audit: 'waterfall_audit',
  unknown: 'unknown',
} as const;
